import { InsiteModelResult } from "interface/util"

export const InviteStatus = {
  Inviting: 0,  // 招待中
  Invited: 1,   // 招待済
  InValid: 2,   // 無効
  Requesting: 3 // 招待申請中
}

export type InviteResult = {
  inviteId: number
  inviteStatus: number
  userName: string | null
  email: string
  effectiveTime: string
  comment: string | null
  inviteUserId?: number
  inviteUserName?: string
  groups: {
    groupId: number
    groupName: string
  }[]
} & InsiteModelResult

export type InviteResultList = {
	list: InviteResult[]
}

export type InviteFormData = {
  userName: string | null
	email: string
  groups: number[]
}

export type InviteRequestFormData = {
  userName: string
  email: string
  comment: string
}
export type InviteApplovalFormData = {
  groups: number[]
}
export type InviteRejectFormData = {
  comment: string
}
